<template>
  <Admin>
    <v-main class="wrapper">
      <v-container fluid>
        <!-- Header -->
        <div class="tw-flex tw-items-center tw-justify-between tw-mb-6">
          <div class="tw-flex tw-items-center tw-gap-3">
            <v-icon large color="indigo darken-2">mdi-file-clock</v-icon>
            <div>
              <h2 class="tw-text-xl tw-font-bold">Loading File Log</h2>
              <p class="tw-text-sm tw-text-gray-500 tw-m-0">ติดตามสถานะการประมวลผลเอกสารแบบ Real-time ตั้งแต่อัปโหลดจนถึงโพสต์เข้าระบบ</p>
            </div>
          </div>
          <div class="tw-flex tw-items-center tw-gap-2">
            <v-chip v-if="isLoading" small color="blue" text-color="white">
              <v-progress-circular indeterminate size="14" width="2" color="white" class="tw-mr-1" />
              กำลังโหลด...
            </v-chip>
            <v-chip v-else small color="green" text-color="white">
              <v-icon left x-small>mdi-check-circle</v-icon>
              Live
            </v-chip>
          </div>
        </div>

        <!-- Summary Cards -->
        <div class="tw-grid tw-grid-cols-4 tw-gap-4 tw-mb-4">
          <div class="tw-border tw-shadow-lg tw-border-gray-300 tw-rounded-xl tw-p-4 tw-flex tw-items-center tw-gap-3">
            <v-icon class="tw-text-3xl tw-bg-blue-500 tw-p-2 tw-rounded-full" color="white">mdi-file-document-multiple</v-icon>
            <div>
              <h1 class="tw-text-2xl tw-font-bold tw-text-blue-500">{{ totalFilesAll }}</h1>
              <h4 class="tw-text-xs tw-text-gray-500">ไฟล์ที่อัปโหลดทั้งหมด</h4>
            </div>
          </div>
          <div class="tw-border tw-shadow-lg tw-border-gray-300 tw-rounded-xl tw-p-4 tw-flex tw-items-center tw-gap-3">
            <v-icon class="tw-text-3xl tw-bg-indigo-500 tw-p-2 tw-rounded-full" color="white">mdi-cog-sync</v-icon>
            <div>
              <h1 class="tw-text-2xl tw-font-bold tw-text-indigo-500">{{ totalFilesProcessing }}</h1>
              <h4 class="tw-text-xs tw-text-gray-500">กำลังประมวลผล</h4>
            </div>
          </div>
          <div class="tw-border tw-shadow-lg tw-border-gray-300 tw-rounded-xl tw-p-4 tw-flex tw-items-center tw-gap-3">
            <v-icon class="tw-text-3xl tw-bg-green-500 tw-p-2 tw-rounded-full" color="white">mdi-check-decagram</v-icon>
            <div>
              <h1 class="tw-text-2xl tw-font-bold tw-text-green-500">{{ totalFilesCompleted }}</h1>
              <h4 class="tw-text-xs tw-text-gray-500">ประมวลผลเสร็จ (มีใน PI แล้ว)</h4>
            </div>
          </div>
          <div class="tw-border tw-shadow-lg tw-border-gray-300 tw-rounded-xl tw-p-4 tw-flex tw-items-center tw-gap-3">
            <v-icon class="tw-text-3xl tw-bg-red-500 tw-p-2 tw-rounded-full" color="white">mdi-alert-circle</v-icon>
            <div>
              <h1 class="tw-text-2xl tw-font-bold tw-text-red-500">{{ totalFilesError }}</h1>
              <h4 class="tw-text-xs tw-text-gray-500">ไฟล์ที่มีปัญหา</h4>
            </div>
          </div>
        </div>

        <!-- Invoice Summary Cards -->
        <div class="tw-grid tw-grid-cols-6 tw-gap-4 tw-mb-6">
          <div class="tw-border tw-shadow tw-border-gray-200 tw-rounded-xl tw-p-3 tw-flex tw-items-center tw-gap-2">
            <v-icon class="tw-bg-blue-400 tw-p-1.5 tw-rounded-full" small color="white">mdi-file-send</v-icon>
            <div>
              <h1 class="tw-text-lg tw-font-bold tw-text-blue-400">{{ totalPosting }}</h1>
              <h4 class="tw-text-xs tw-text-gray-500">กำลังโพสต์</h4>
            </div>
          </div>
          <div class="tw-border tw-shadow tw-border-gray-200 tw-rounded-xl tw-p-3 tw-flex tw-items-center tw-gap-2">
            <v-icon class="tw-bg-green-500 tw-p-1.5 tw-rounded-full" small color="white">mdi-check-bold</v-icon>
            <div>
              <h1 class="tw-text-lg tw-font-bold tw-text-green-500">{{ totalSuccess }}</h1>
              <h4 class="tw-text-xs tw-text-gray-500">โพสต์สำเร็จ</h4>
            </div>
          </div>
          <div class="tw-border tw-shadow tw-border-gray-200 tw-rounded-xl tw-p-3 tw-flex tw-items-center tw-gap-2">
            <v-icon style="background-color: #FBBF24" class="tw-p-1.5 tw-rounded-full" small color="white">mdi-clock-check</v-icon>
            <div>
              <h1 class="tw-text-lg tw-font-bold" style="color: #FBBF24">{{ totalPendingApproval }}</h1>
              <h4 class="tw-text-xs tw-text-gray-500">รออนุมัติ</h4>
            </div>
          </div>
          <div class="tw-border tw-shadow tw-border-gray-200 tw-rounded-xl tw-p-3 tw-flex tw-items-center tw-gap-2">
            <v-icon class="tw-bg-warning tw-p-1.5 tw-rounded-full" small color="white">mdi-alert</v-icon>
            <div>
              <h1 class="tw-text-lg tw-font-bold tw-text-warning">{{ totalWarning }}</h1>
              <h4 class="tw-text-xs tw-text-gray-500">มีคำเตือน</h4>
            </div>
          </div>
          <div class="tw-border tw-shadow tw-border-gray-200 tw-rounded-xl tw-p-3 tw-flex tw-items-center tw-gap-2">
            <v-icon class="tw-bg-red-600 tw-p-1.5 tw-rounded-full" small color="white">mdi-close-octagon</v-icon>
            <div>
              <h1 class="tw-text-lg tw-font-bold tw-text-red-600">{{ totalInvoiceError }}</h1>
              <h4 class="tw-text-xs tw-text-gray-500">ข้อผิดพลาด</h4>
            </div>
          </div>
          <div class="tw-border tw-shadow tw-border-gray-200 tw-rounded-xl tw-p-3 tw-flex tw-items-center tw-gap-2">
            <v-icon class="tw-bg-gray-500 tw-p-1.5 tw-rounded-full" small color="white">mdi-cancel</v-icon>
            <div>
              <h1 class="tw-text-lg tw-font-bold tw-text-gray-500">{{ totalRejected }}</h1>
              <h4 class="tw-text-xs tw-text-gray-500">ถูกปฏิเสธ</h4>
            </div>
          </div>
        </div>

        <!-- Status Legend -->
        <v-expansion-panels flat class="tw-mb-6">
          <v-expansion-panel class="tw-border tw-border-gray-200 tw-rounded-xl tw-bg-gray-50">
            <v-expansion-panel-header class="tw-font-bold tw-text-sm">
              <div class="tw-flex tw-items-center tw-gap-2">
                <v-icon small>mdi-information</v-icon>
                คำอธิบายสถานะแต่ละขั้นตอน (คลิกเพื่อดู)
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="tw-grid tw-grid-cols-2 tw-gap-x-8 tw-gap-y-3 tw-text-sm">
                <div class="tw-border-l-4 tw-border-cyan-500 tw-pl-3">
                  <v-chip x-small color="cyan" text-color="white" class="tw-mb-1">NEW</v-chip>
                  <p class="tw-text-gray-600 tw-m-0">ไฟล์เพิ่งถูกอัปโหลดเข้าระบบ — ระบบรับไฟล์แล้วและบันทึกข้อมูลไฟล์ลงใน Staging พร้อมเข้าคิวประมวลผล ยังไม่มีการดึงข้อมูลใดๆ จากไฟล์</p>
                </div>
                <div class="tw-border-l-4 tw-border-indigo-500 tw-pl-3">
                  <v-chip x-small color="indigo" text-color="white" class="tw-mb-1">PROCESSING</v-chip>
                  <p class="tw-text-gray-600 tw-m-0">กำลังประมวลผลไฟล์ — ระบบกำลังสกัดข้อความจาก PDF ด้วย Document AI / Vision API จากนั้นส่งข้อความไปยัง AI เพื่อแปลงเป็นข้อมูลใบแจ้งหนี้ ขั้นตอนนี้อาจใช้เวลาหลายวินาทีถึงหลายนาที</p>
                </div>
                <div class="tw-border-l-4 tw-border-amber-500 tw-pl-3">
                  <v-chip x-small color="#FBBF24" text-color="white" class="tw-mb-1">PENDING_APPROVAL</v-chip>
                  <p class="tw-text-gray-600 tw-m-0">ประมวลผลเสร็จแล้ว รอการตรวจสอบและอนุมัติจากผู้ใช้ — ระบบดึงข้อมูลจากเอกสารเรียบร้อยแล้ว กรุณาตรวจสอบความถูกต้องของข้อมูลก่อนกดอนุมัติเพื่อส่งเข้าระบบบัญชี</p>
                </div>
                <div class="tw-border-l-4 tw-border-blue-500 tw-pl-3">
                  <v-chip x-small color="blue" text-color="white" class="tw-mb-1">POSTING</v-chip>
                  <p class="tw-text-gray-600 tw-m-0">กำลังส่งข้อมูลเข้าสู่ระบบบัญชี (ERP) — ระบบกำลังบันทึกข้อมูลเอกสารไปยังระบบปลายทาง รอยืนยันผลลัพธ์จาก ERP ห้ามแก้ไขเอกสารในขั้นตอนนี้</p>
                </div>
                <div class="tw-border-l-4 tw-border-green-500 tw-pl-3">
                  <v-chip x-small color="green" text-color="white" class="tw-mb-1">SUCCESS</v-chip>
                  <p class="tw-text-gray-600 tw-m-0">โพสต์เข้าระบบบัญชีสำเร็จเรียบร้อย — เอกสารถูกบันทึกเข้าระบบ ERP แล้ว มีเลขที่เอกสารอ้างอิงจากระบบปลายทาง กระบวนการเสร็จสมบูรณ์ไม่ต้องดำเนินการเพิ่มเติม</p>
                </div>
                <div class="tw-border-l-4 tw-border-orange-500 tw-pl-3">
                  <v-chip x-small color="orange" text-color="white" class="tw-mb-1">WARNING</v-chip>
                  <p class="tw-text-gray-600 tw-m-0">ประมวลผลสำเร็จแต่พบข้อมูลที่ไม่ตรงกัน — ระบบตรวจพบว่ามีบางฟิลด์ที่อาจไม่ถูกต้อง เช่น เลขที่ผู้เสียภาษีไม่ตรงกับฐานข้อมูล, รหัสสาขาไม่พบ, หรือยอดเงินไม่ตรง กรุณาตรวจสอบและแก้ไขก่อนอนุมัติ</p>
                </div>
                <div class="tw-border-l-4 tw-border-red-500 tw-pl-3">
                  <v-chip x-small color="red" text-color="white" class="tw-mb-1">ERROR</v-chip>
                  <p class="tw-text-gray-600 tw-m-0">เกิดข้อผิดพลาดระหว่างประมวลผล — ระบบไม่สามารถดึงข้อมูลจากเอกสารได้ครบถ้วน อาจเกิดจากไฟล์เสียหาย, รูปแบบเอกสารไม่รองรับ, หรือข้อมูลสำคัญขาดหาย ต้องตรวจสอบไฟล์ต้นฉบับและอัปโหลดใหม่</p>
                </div>
                <div class="tw-border-l-4 tw-border-gray-500 tw-pl-3">
                  <v-chip x-small color="grey" text-color="white" class="tw-mb-1">REJECTED</v-chip>
                  <p class="tw-text-gray-600 tw-m-0">เอกสารถูกปฏิเสธโดยระบบ — ไฟล์ไม่ผ่านการตรวจสอบเบื้องต้น อาจเป็นไฟล์ซ้ำ, ประเภทไฟล์ไม่ถูกต้อง, หรือไม่สามารถอ่านข้อมูลได้ ดูสาเหตุในคอลัมน์ "สาเหตุที่ล้มเหลว" สำหรับรายละเอียดเพิ่มเติม</p>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- Processing Progress -->
        <div class="tw-mb-6">
          <div class="tw-flex tw-items-center tw-gap-2 tw-mb-2">
            <v-icon small color="indigo">mdi-chart-timeline-variant</v-icon>
            <span class="tw-font-bold">ความคืบหน้าการประมวลผล</span>
            <span class="tw-text-sm tw-text-gray-400">({{ totalFilesCompleted }}/{{ totalFilesAll }} ไฟล์ — {{ progressPct }}%)</span>
          </div>
          <v-progress-linear
            :value="progressPct"
            height="20"
            rounded
            color="green"
            background-color="grey lighten-3"
          >
            <template v-slot:default>
              <span class="tw-text-xs tw-font-bold white--text">{{ progressPct }}%</span>
            </template>
          </v-progress-linear>
        </div>

        <!-- ===== SECTION 1: PurchaseInvoiceFiles (Staging) ===== -->
        <h3 class="tw-text-lg tw-font-bold tw-mb-3">
          <v-icon small class="tw-mr-1" color="indigo">mdi-upload</v-icon>
          ไฟล์ที่อัปโหลด — Staging ({{ invoiceFiles.length }})
        </h3>
        <v-data-table
          dense
          :headers="headersFiles"
          :items="invoiceFiles"
          :items-per-page="25"
          item-key="id"
          class="elevation-1 tw-mb-8"
          :loading="isLoadingFiles"
          loading-text="กำลังโหลดข้อมูลไฟล์..."
          sort-by="timestamp"
          :sort-desc="true"
          :footer-props="{ 'items-per-page-options': [10, 25, 50, 100, -1] }"
        >
          <template v-slot:item.status="{ item }">
            <v-chip
              x-small
              :color="getFileStatusColor(item.status)"
              text-color="white"
              class="tw-font-bold"
            >
              {{ item.status || 'NEW' }}
            </v-chip>
          </template>

          <template v-slot:item.statusDescription="{ item }">
            <span class="tw-text-xs tw-text-gray-600">{{ getFileStatusDescription(item.status) }}</span>
          </template>

          <template v-slot:item.timestamp="{ item }">
            <span class="tw-text-xs">{{ formatTimestamp(item.timestamp) }}</span>
          </template>

          <template v-slot:item.uploadFrom="{ item }">
            <v-chip x-small outlined :color="item.uploadFrom === 'GoogleDrive' ? 'blue' : 'purple'">
              <v-icon x-small left>{{ item.uploadFrom === 'GoogleDrive' ? 'mdi-google-drive' : 'mdi-upload' }}</v-icon>
              {{ item.uploadFrom || 'Client' }}
            </v-chip>
          </template>

          <template v-slot:item.linkedInvoice="{ item }">
            <v-chip v-if="fileToInvoiceMap[item.id]" x-small color="green" text-color="white">
              <v-icon x-small left>mdi-link</v-icon>
              มีใน PI แล้ว
            </v-chip>
            <span v-else class="tw-text-xs tw-text-gray-400">รอประมวลผล</span>
          </template>
        </v-data-table>

        <!-- ===== SECTION 2: PurchaseInvoices (Processed) ===== -->
        <h3 class="tw-text-lg tw-font-bold tw-mb-3">
          <v-icon small class="tw-mr-1" color="green">mdi-file-check</v-icon>
          เอกสารที่ประมวลผลแล้ว — PurchaseInvoices ({{ purchaseInvoices.length }})
        </h3>
        <v-data-table
          dense
          :headers="headersInvoices"
          :items="purchaseInvoices"
          :items-per-page="25"
          item-key="id"
          class="elevation-1"
          :loading="isLoadingInvoices"
          loading-text="กำลังโหลดข้อมูลเอกสาร..."
          sort-by="timeCreate"
          :sort-desc="true"
          :footer-props="{ 'items-per-page-options': [10, 25, 50, 100, -1] }"
        >
          <template v-slot:item.status="{ item }">
            <v-chip
              x-small
              :color="getInvoiceStatusColor(item.status)"
              text-color="white"
              class="tw-font-bold"
            >
              {{ item.status }}
            </v-chip>
          </template>

          <template v-slot:item.statusDescription="{ item }">
            <span class="tw-text-xs tw-text-gray-600">{{ getInvoiceStatusDescription(item.status) }}</span>
          </template>

          <template v-slot:item.timeCreate="{ item }">
            <span class="tw-text-xs">{{ formatTimestamp(item.timeCreate) }}</span>
          </template>

          <template v-slot:item.failureMessage="{ item }">
            <span v-if="item.failureMessage" class="tw-text-xs tw-text-red-600">{{ item.failureMessage }}</span>
            <span v-else class="tw-text-xs tw-text-gray-400">-</span>
          </template>
        </v-data-table>

        <!-- Google Drive Stats -->
        <div class="tw-mt-8 tw-border tw-shadow-lg tw-border-gray-200 tw-rounded-xl tw-p-4">
          <div class="tw-flex tw-items-center tw-justify-between tw-mb-4">
            <div class="tw-flex tw-items-center tw-gap-2">
              <v-icon color="blue darken-2">mdi-google-drive</v-icon>
              <span class="tw-font-bold tw-text-base tw-text-gray-700">Google Drive — สถิติการรับไฟล์</span>
            </div>
            <v-btn x-small text color="grey" :loading="isLoadingDriveStats" @click="loadDriveStats">
              <v-icon left x-small>mdi-refresh</v-icon>
              รีเฟรช
            </v-btn>
          </div>

          <div v-if="isLoadingDriveStats" class="tw-flex tw-justify-center tw-py-6">
            <v-progress-circular indeterminate color="primary" size="28" />
          </div>

          <div v-else-if="!driveStats" class="tw-text-center tw-text-gray-400 tw-text-sm tw-py-4">
            ยังไม่มีข้อมูล Google Drive (จะปรากฏหลังจากมีไฟล์เข้ามาครั้งแรก)
          </div>

          <div v-else>
            <div class="tw-grid tw-grid-cols-2 tw-gap-3 sm:tw-grid-cols-5">
              <div class="tw-border tw-shadow tw-border-blue-100 tw-rounded-xl tw-p-4 tw-flex tw-items-center tw-gap-3">
                <v-icon class="tw-bg-blue-500 tw-p-2 tw-rounded-full" color="white">mdi-webhook</v-icon>
                <div>
                  <h1 class="tw-text-2xl tw-font-bold tw-text-blue-500">{{ driveStats.totalWebhookEvents || 0 }}</h1>
                  <h4 class="tw-text-xs tw-text-gray-500">Webhook (มีไฟล์)</h4>
                </div>
              </div>
              <div class="tw-border tw-shadow tw-border-gray-100 tw-rounded-xl tw-p-4 tw-flex tw-items-center tw-gap-3">
                <v-icon class="tw-bg-gray-400 tw-p-2 tw-rounded-full" color="white">mdi-bell-outline</v-icon>
                <div>
                  <h1 class="tw-text-2xl tw-font-bold tw-text-gray-500">{{ driveStats.totalWebhookPings || 0 }}</h1>
                  <h4 class="tw-text-xs tw-text-gray-500">Ping ทั้งหมด</h4>
                </div>
              </div>
              <div class="tw-border tw-shadow tw-border-indigo-100 tw-rounded-xl tw-p-4 tw-flex tw-items-center tw-gap-3">
                <v-icon class="tw-bg-indigo-500 tw-p-2 tw-rounded-full" color="white">mdi-file-search</v-icon>
                <div>
                  <h1 class="tw-text-2xl tw-font-bold tw-text-indigo-500">{{ driveStats.totalFilesDetected || 0 }}</h1>
                  <h4 class="tw-text-xs tw-text-gray-500">ไฟล์ที่ตรวจพบ</h4>
                </div>
              </div>
              <div class="tw-border tw-shadow tw-border-green-100 tw-rounded-xl tw-p-4 tw-flex tw-items-center tw-gap-3">
                <v-icon class="tw-bg-green-500 tw-p-2 tw-rounded-full" color="white">mdi-check-circle</v-icon>
                <div>
                  <h1 class="tw-text-2xl tw-font-bold tw-text-green-500">{{ driveStats.totalFilesProcessed || 0 }}</h1>
                  <h4 class="tw-text-xs tw-text-gray-500">ประมวลผลสำเร็จ</h4>
                </div>
              </div>
              <div class="tw-border tw-shadow tw-border-red-100 tw-rounded-xl tw-p-4 tw-flex tw-items-center tw-gap-3">
                <v-icon class="tw-bg-red-500 tw-p-2 tw-rounded-full" color="white">mdi-alert-circle</v-icon>
                <div>
                  <h1 class="tw-text-2xl tw-font-bold tw-text-red-500">{{ driveStats.totalFilesError || 0 }}</h1>
                  <h4 class="tw-text-xs tw-text-gray-500">ข้อผิดพลาด</h4>
                </div>
              </div>
            </div>

            <div class="tw-mt-4 tw-flex tw-flex-wrap tw-gap-4 tw-text-xs tw-text-gray-500 tw-border-t tw-border-gray-100 tw-pt-3">
              <span v-if="driveStats.totalProcessingRuns">
                <v-icon x-small>mdi-timer-outline</v-icon>
                เวลาเฉลี่ย: <strong class="tw-text-gray-700">{{ avgProcessingTime }}</strong>
              </span>
              <span v-if="driveStats.lastWebhookAt">
                <v-icon x-small>mdi-clock-outline</v-icon>
                Webhook ล่าสุด: <strong class="tw-text-gray-700">{{ formatDriveDate(driveStats.lastWebhookAt) }}</strong>
              </span>
              <span v-if="driveStats.lastProcessedAt">
                <v-icon x-small>mdi-calendar-check</v-icon>
                ประมวลผลล่าสุด: <strong class="tw-text-gray-700">{{ formatDriveDate(driveStats.lastProcessedAt) }}</strong>
              </span>
              <span v-if="driveStats.lastProcessingDurationMs">
                <v-icon x-small>mdi-flash</v-icon>
                ครั้งล่าสุดใช้: <strong class="tw-text-gray-700">{{ (driveStats.lastProcessingDurationMs / 1000).toFixed(1) }}s</strong>
              </span>
            </div>
          </div>
        </div>
      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import Admin from "@/components/admin/admin-main-template";
import fc from "@/firebaseConfig";
import moment from "moment";

export default {
  name: "LoadingFileLog",
  components: { Admin },
  data() {
    return {
      invoiceFiles: [],
      purchaseInvoices: [],
      isLoadingFiles: false,
      isLoadingInvoices: false,
      unsubscribeFiles: null,
      unsubscribeInvoices: null,
      driveStats: null,
      isLoadingDriveStats: false,
      headersFiles: [
        { text: "เวลาที่อัปโหลด", value: "timestamp", width: "160px" },
        { text: "ชื่อไฟล์", value: "fileName" },
        { text: "ประเภทไฟล์", value: "extension", width: "100px" },
        { text: "อัปโหลดจาก", value: "uploadFrom", width: "140px" },
        { text: "สถานะ", value: "status", width: "140px" },
        { text: "คำอธิบายสถานะ", value: "statusDescription", width: "300px", sortable: false },
        { text: "เชื่อมต่อ Invoice", value: "linkedInvoice", width: "150px", sortable: false },
      ],
      headersInvoices: [
        { text: "เวลาที่เข้าระบบ", value: "timeCreate", width: "160px" },
        { text: "ชื่อไฟล์", value: "fileName" },
        { text: "สถานะ", value: "status", width: "160px" },
        { text: "คำอธิบายสถานะ", value: "statusDescription", width: "300px", sortable: false },
        { text: "เลขที่เอกสาร", value: "docId" },
        { text: "รหัสผู้จำหน่าย", value: "cardCode" },
        { text: "ชื่อผู้จำหน่าย", value: "cardName" },
        { text: "สาเหตุที่ล้มเหลว", value: "failureMessage", sortable: false },
      ],
    };
  },
  computed: {
    isLoading() {
      return this.isLoadingFiles || this.isLoadingInvoices;
    },
    // File-level stats
    totalFilesAll() {
      return this.invoiceFiles.length;
    },
    totalFilesProcessing() {
      return this.invoiceFiles.filter(f =>
        f.status === "NEW" || f.status === "PROCESSING"
      ).length;
    },
    totalFilesCompleted() {
      return this.invoiceFiles.filter(f => this.fileToInvoiceMap[f.id]).length;
    },
    totalFilesError() {
      return this.invoiceFiles.filter(f => f.status === "ERROR").length;
    },
    // Invoice-level stats
    totalSuccess() {
      return this.purchaseInvoices.filter(d => d.status === "SUCCESS").length;
    },
    totalPendingApproval() {
      return this.purchaseInvoices.filter(d => d.status === "PENDING_APPROVAL").length;
    },
    totalPosting() {
      return this.purchaseInvoices.filter(d => d.status === "POSTING").length;
    },
    totalWarning() {
      return this.purchaseInvoices.filter(d => d.status === "WARNING").length;
    },
    totalInvoiceError() {
      return this.purchaseInvoices.filter(d => d.status === "ERROR").length;
    },
    totalRejected() {
      return this.purchaseInvoices.filter(d => d.status === "REJECTED").length;
    },
    progressPct() {
      if (this.totalFilesAll === 0) return 0;
      return Math.round((this.totalFilesCompleted / this.totalFilesAll) * 100);
    },
    // Map fileDocRef from PurchaseInvoices back to PurchaseInvoiceFiles
    fileToInvoiceMap() {
      const map = {};
      this.purchaseInvoices.forEach(inv => {
        if (inv.fileDocRef) {
          map[inv.fileDocRef] = inv;
        }
      });
      return map;
    },
    avgProcessingTime() {
      if (!this.driveStats) return "-";
      const runs = this.driveStats.totalProcessingRuns || 0;
      const total = this.driveStats.totalProcessingTimeMs || 0;
      if (!runs) return "-";
      const avg = total / runs;
      return avg >= 1000 ? (avg / 1000).toFixed(1) + "s" : Math.round(avg) + "ms";
    },
  },
  methods: {
    // File statuses
    getFileStatusColor(status) {
      const colors = {
        NEW: "cyan",
        PROCESSING: "indigo",
        ERROR: "red",
      };
      return colors[status] || "cyan";
    },
    getFileStatusDescription(status) {
      const descriptions = {
        NEW: "ไฟล์เพิ่งถูกอัปโหลด — รอเข้าคิวประมวลผล ระบบจะเริ่มสกัดข้อความจากไฟล์โดยอัตโนมัติ",
        PROCESSING: "กำลังประมวลผล — ระบบกำลังสกัดข้อความจาก PDF และส่งให้ AI แปลงเป็นข้อมูลใบแจ้งหนี้",
        ERROR: "เกิดข้อผิดพลาดในการประมวลผลไฟล์ — อาจเกิดจากไฟล์เสียหายหรือรูปแบบไม่รองรับ",
      };
      return descriptions[status] || "ไฟล์เพิ่งถูกอัปโหลด — รอเข้าคิวประมวลผล";
    },
    // Invoice statuses
    getInvoiceStatusColor(status) {
      const colors = {
        POSTING: "blue",
        SUCCESS: "green",
        PENDING_APPROVAL: "#FBBF24",
        WARNING: "orange",
        ERROR: "red",
        REJECTED: "grey",
      };
      return colors[status] || "grey lighten-1";
    },
    getInvoiceStatusDescription(status) {
      const descriptions = {
        POSTING: "กำลังส่งข้อมูลเข้าสู่ระบบบัญชี (ERP) — รอยืนยันผลลัพธ์",
        SUCCESS: "โพสต์เข้าระบบบัญชีสำเร็จ — กระบวนการเสร็จสมบูรณ์",
        PENDING_APPROVAL: "รอตรวจสอบและอนุมัติจากผู้ใช้ — กรุณาตรวจสอบก่อนกดอนุมัติ",
        WARNING: "พบข้อมูลไม่ตรงกัน — กรุณาตรวจสอบและแก้ไขก่อนอนุมัติ",
        ERROR: "เกิดข้อผิดพลาด — ไม่สามารถดึงข้อมูลได้ครบ ต้องตรวจสอบไฟล์ต้นฉบับ",
        REJECTED: "ถูกปฏิเสธ — ไฟล์ไม่ผ่านการตรวจสอบ ดูสาเหตุในคอลัมน์สาเหตุที่ล้มเหลว",
      };
      return descriptions[status] || "สถานะไม่ทราบ";
    },
    formatTimestamp(ts) {
      if (!ts) return "-";
      if (ts.seconds) {
        return moment(new Date(ts.seconds * 1000)).format("DD/MM/YYYY HH:mm:ss");
      }
      if (ts.toDate) {
        return moment(ts.toDate()).format("DD/MM/YYYY HH:mm:ss");
      }
      return moment(ts).format("DD/MM/YYYY HH:mm:ss");
    },
    formatDriveDate(val) {
      if (!val) return "";
      const d = val instanceof Date ? val : val.toDate ? val.toDate() : new Date(val);
      return moment(d).format("DD/MM/YYYY HH:mm:ss");
    },
    async loadDriveStats() {
      this.isLoadingDriveStats = true;
      try {
        const companyId = this.$route.params.companyId;
        const snap = await fc.db
          .collection("Companies").doc(companyId)
          .collection("GoogleDriveStats").doc("summary")
          .get();
        this.driveStats = snap.exists ? snap.data() : null;
      } catch (err) {
        console.error("loadDriveStats error:", err);
        this.driveStats = null;
      } finally {
        this.isLoadingDriveStats = false;
      }
    },
    setupFileListener() {
      this.isLoadingFiles = true;
      const companyID = this.$route.params.companyId;
      this.unsubscribeFiles = fc.db
        .collection(`Companies/${companyID}/PurchaseInvoiceFiles`)
        .orderBy("timestamp", "desc")
        .onSnapshot(snapshot => {
          this.invoiceFiles = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
          }));
          this.isLoadingFiles = false;
        });
    },
    setupInvoiceListener() {
      this.isLoadingInvoices = true;
      const companyID = this.$route.params.companyId;
      this.unsubscribeInvoices = fc.db
        .collection(`Companies/${companyID}/PurchaseInvoices`)
        .orderBy("timeCreate", "desc")
        .onSnapshot(snapshot => {
          this.purchaseInvoices = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
          }));
          this.isLoadingInvoices = false;
        });
    },
  },
  mounted() {
    this.setupFileListener();
    this.setupInvoiceListener();
    this.loadDriveStats();
  },
  beforeDestroy() {
    if (this.unsubscribeFiles) this.unsubscribeFiles();
    if (this.unsubscribeInvoices) this.unsubscribeInvoices();
  },
};
</script>

<style scoped>
.v-data-table ::v-deep .v-data-table__wrapper {
  overflow-x: auto;
}
</style>
